import { render } from "./AppDropDownMenuSubmenu.vue?vue&type=template&id=8128d00e"
import script from "./AppDropDownMenuSubmenu.vue?vue&type=script&lang=js"
export * from "./AppDropDownMenuSubmenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__